import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ChangePassword: React.FC = () => {
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
        <>
            <div className="col-12 col-md-8 col-xl-6">
                <div className="h-100 py-4 px-md-3">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-12 col-sm-8 col-md-11 col-xl-11 col-xxl-10 login-box">
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="text-center mb-4">
                                        <h1 className="mb-1 text-theme-1">Thats great step!</h1>
                                        <h4 className="mb-3">You are now one step away</h4>
                                        <p className="text-secondary">Provide you new password and confirm password here and you're all set to go and use DevUIUX template preview.</p>
                                    </div>

                                    <div className="position-relative">
                                        <div className="form-floating mb-3">
                                            <input type={showNewPassword ? "text" : "password"} className="form-control" id="checkstrength" placeholder="Enter your new password" />
                                            <label htmlFor="checkstrength">New Password</label>
                                        </div>
                                        <button
                                            className={`btn btn-square btn-link text-theme-1 position-absolute end-0 top-0 mt-2 me-2 ${showNewPassword ? 'active' : ''}`}
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            type="button"
                                        >
                                            <i className={`bi bi-eye${showNewPassword ? '-slash' : ''}`}></i>
                                        </button>
                                    </div>

                                    <div className="position-relative">
                                        <div className="form-floating mb-4">
                                            <input type={showConfirmPassword ? "text" : "password"} className="form-control" id="passwdconfirm" placeholder="Confirm your new password" />
                                            <label htmlFor="passwdconfirm">Confirm Password</label>
                                        </div>
                                        <button
                                            className={`btn btn-square btn-link text-theme-1 position-absolute end-0 top-0 mt-2 me-2 ${showConfirmPassword ? 'active' : ''}`}
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            type="button"
                                        >
                                            <i className={`bi bi-eye${showConfirmPassword ? '-slash' : ''}`}></i>
                                        </button>
                                    </div>

                                    <Link to="/auth/login" className="btn btn-lg btn-theme w-100 mb-4">Change Now</Link>
                                    <div className="text-center mb-3">
                                        Already have password? <Link to="/auth/login" className="text-theme-1">Login</Link> here.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;
